const TitleScreen = 'titlescreen'
const Game = 'game'
const Chooser = 'chooser'
const GameBackground = 'game-background'
const GameOver = 'game-over'
const Preload = 'preload'
const Pause = 'pause'
const Font = '"Press Start 2P"'
export {
    TitleScreen,
    Game,
    GameBackground,
    GameOver,
    Font,
    Preload,
    Pause
}